import { AnyAction } from "redux";

export const GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN";
export const GET_ACCESS_TOKEN_SUCCESS = "GET_ACCESS_TOKEN_SUCCESS";

export interface IAuthReducer {
  accessToken: string | null;
}

export const getAccessToken = () => ({
  type: GET_ACCESS_TOKEN,
});

export const gotAccessToken = (value: string) => ({
  type: GET_ACCESS_TOKEN_SUCCESS,
  value,
});

export const initialState: IAuthReducer = {
  accessToken: null,
};

export const authReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case GET_ACCESS_TOKEN_SUCCESS:
      const accessToken = action.value;
      return {
        ...state,
        accessToken,
      };
    default:
      return state;
  }
};

export default authReducer;
